import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { modalState } from '../../states/modalState';

const Modal = () => {
  const location = useLocation();
  const [{ isOpen, component }, setModalState] = useRecoilState(modalState);

  useEffect(() => {
    setModalState({ isOpen: false });
  }, [location]);

  if (!isOpen || !component) {
    return;
  }

  return <Container>{component}</Container>;
};

export default Modal;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  padding: 0 20px;
`;
